import React, { useEffect, useState } from "react";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import { Button, Container, ContainertInput, Input, Label } from "./styles";
import { ModalLoader } from "../../../ModalLoader";
import { Alert } from "../../../Error/Alert";
import api from "../../../../Services/api";
import { useParams } from "react-router";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { useCartorio } from "../../../../Hooks/cartorio";
import { isRural } from "../../../../Utils/isRural";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "20%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  numeroGuia: number;
  handleSetGuia(n: number): void;
  prefeitura_id: number;
}

export function ModalGuia({
  open,
  onClose,
  numeroGuia,
  handleSetGuia,
  prefeitura_id,
}: Props) {
  const { cartorioIsLogged, cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();

  const { prefeitura } = usePrefeitura();
  const { id } = useParams();

  const [GUIA, setGUIA] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  useEffect(() => {
    if (numeroGuia) {
      setGUIA(numeroGuia);
    }
  }, [numeroGuia]);

  async function post() {
    try {
      setLoading(true);

      // if (cartorioIsLogged) {
      //   await checarToken();
      // }

      // if (funcionarioCartorioIsLogged) {
      //   await checarTokenFuncionario();
      // }

      const { data } = await api.patch(
        `/imovel${isRural() ? "-rural" : ""}/atera-numero-guia`,
        {
          id,
          guia: GUIA,
          entidade_id: prefeitura_id,
        }
      );

      if (data.status == false) {
        setError({ title: "Ops", message: data.mensagem });
        return;
      }

      handleSetGuia(GUIA);
      onClose();
    } catch (error) {
      setError({
        message: "Não foi possível atualizar a numeração da guia do imóvel!",
        title: "Erro ao atualizar imóvel!",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <ContainertInput>
          <Label>
            NÚMERO DE GUIA
            <Input
              value={GUIA}
              type={"text"}
              placeholder={"NÚMERO DA GUIA"}
              onChange={(ev) =>
                setGUIA(Number(ev.target.value.replace(/\D/g, "")))
              }
            />
          </Label>
        </ContainertInput>
        <span>
          Se deixar o número da guia como zero, ao avaliar um número de
          autoincremento será adicionado automaticamente!
        </span>
        <Button onClick={post}>CONFIMAR</Button>
      </Container>

      <ModalLoader loading={loading} />
      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </Modal>
  );
}
